import {isFeatureEnabled} from 'feature-flags';

import {featureFlags} from '@dms/feature-flags';

export const isUnifiedSourcingEnabled = () =>
  isFeatureEnabled(featureFlags.SOURCING_UNIFIED_SURFACES);
